import { ElementType, PropsWithChildren, useEffect, useState } from 'react';
import { Item } from '../item/item';
import './style.module.scss';
import styles from './style.module.scss';

interface IProps extends React.HTMLAttributes<HTMLHeadingElement> {
	tag?: ElementType;
}

export function IconWithLabel({ className, children, tag: Tag = 'p' }: PropsWithChildren<IProps>) {
	return <Tag className={`${styles.icon} ${className}`}>{children}</Tag>;
}
